import "./UserAE.css";
import InputCus from "../../Component/InputCus/Text/InputCus";
import {  useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { UsersAddExpDay } from "../../Api/Services";

function UserAE() {
  const [isLoading, setLoading] = useState(false);
  const [form, setForm] = useState({});

  const navigate = useNavigate();

  let { id } = useParams();

  const AddUpdate = async () => {
    let validation = true;
    if (form.Days === "") {
      toast.error("روز را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setLoading(true);
      try {
        if (id) {
          const UsersAddExpDayData = await UsersAddExpDay({ ...form, UserId:id });
          if (UsersAddExpDayData.status && UsersAddExpDayData.status === 200) {
            toast.success("بروزرسانی با موفقیت انجام شد");
            navigate("/Panel/User");
          }
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleChangeSearch = (e) => {
    const newForm = { ...form };
    newForm[e.target.id] = e.target.value;
    setForm(newForm);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-between align-items-start p-5">
          <div className="d-flex justify-content-start align-items-center flex-column element w-100 p-5">
            <div className="d-flex justify-content-start align-items-center flex-wrap  ">
              <InputCus
                type="text"
                name="days"
                id="days"
                text="تعداد روز"
                value={form.days || ""}
                onChange={handleChangeSearch}
                className="m-2"
              />
            </div>
            <div className="d-flex justify-content-start align-items-center w-100 m-5">
              <button
                onClick={() => {
                  AddUpdate();
                }}
                className="butAU"
              >
                {"افزودن"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserAE;
